export default function PHP_debug() {
  return (
    <div>
      <h1>PHP_debug</h1>
    </div>
  );
}
